<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        viewbox-width="16"
        viewbox-height="16"
        :color="color"
        @click="$emit('click')"
    >
        <path
            class="a"
            d="M0.502197 16.0007C0.443531 16.0007 0.385531 15.99 0.328864 15.9693C0.323531 15.9673 0.318864 15.966 0.314197 15.964C0.188864 15.9127 0.0901973 15.8133 0.0395306 15.6907C0.0375306 15.686 0.0355306 15.6807 0.0335306 15.6753C0.0135306 15.6207 0.00219727 15.5613 0.00219727 15.5007V11.0007C0.00219727 10.7247 0.226197 10.5007 0.502197 10.5007C0.778197 10.5007 1.0022 10.7247 1.0022 11.0007V14.2933L6.14886 9.14667C6.24353 9.052 6.36886 9 6.5022 9C6.63553 9 6.76153 9.052 6.85553 9.14667C6.9502 9.24133 7.0022 9.36667 7.0022 9.5C7.0022 9.63333 6.9502 9.75933 6.85553 9.85333L1.70886 15H5.0022C5.2782 15 5.5022 15.224 5.5022 15.5C5.5022 15.776 5.2782 16 5.0022 16L0.502197 16.0007Z"
        />
        <path
            class="a"
            d="M9.5022 7C9.36886 7 9.24286 6.948 9.14886 6.85333C9.0542 6.75933 9.0022 6.63333 9.0022 6.5C9.0022 6.36667 9.0542 6.24067 9.14886 6.14667L14.2955 1H11.0022C10.7262 1 10.5022 0.776 10.5022 0.5C10.5022 0.224 10.7262 0 11.0022 0H15.5022C15.5615 0 15.6195 0.0106667 15.6762 0.032C15.6835 0.0346667 15.6909 0.0373333 15.6975 0.04C15.8149 0.088 15.9135 0.187333 15.9642 0.309333C15.9662 0.314667 15.9689 0.320667 15.9709 0.326667C15.9915 0.381333 16.0022 0.440667 16.0022 0.5V5C16.0022 5.276 15.7782 5.5 15.5022 5.5C15.2262 5.5 15.0022 5.276 15.0022 5V1.70733L9.85553 6.854C9.76153 6.948 9.63553 7 9.5022 7Z"
        />
        <path
            class="a"
            d="M11.0021 16C10.7261 16 10.5021 15.776 10.5021 15.5C10.5021 15.224 10.7261 15 11.0021 15H14.2948L9.14813 9.85333C9.05347 9.75867 9.00146 9.63333 9.00146 9.5C9.00146 9.36667 9.05347 9.24067 9.14813 9.14667C9.2428 9.05267 9.36813 9 9.50146 9C9.6348 9 9.7608 9.052 9.8548 9.14667L15.0015 14.2933V11.0007C15.0015 10.7247 15.2255 10.5007 15.5015 10.5007C15.7775 10.5007 16.0021 10.724 16.0021 11V15.5C16.0021 15.558 15.9915 15.616 15.9708 15.672C15.9695 15.676 15.9681 15.6793 15.9668 15.6833C15.9135 15.8133 15.8141 15.912 15.6921 15.9627C15.6868 15.9647 15.6808 15.9673 15.6748 15.9693C15.6201 15.99 15.5615 16.0007 15.5021 16.0007H11.0021V16Z"
        />
        <path
            class="a"
            d="M6.5022 7C6.36886 7 6.24286 6.948 6.14886 6.85333L1.0022 1.70733V5C1.0022 5.276 0.778197 5.5 0.502197 5.5C0.226197 5.5 0.00219727 5.276 0.00219727 5V0.5C0.00219727 0.441333 0.0128639 0.382667 0.0341973 0.326C0.0355306 0.321333 0.0375306 0.316667 0.0388639 0.312C0.0901973 0.187333 0.189531 0.088 0.312197 0.038C0.316864 0.036 0.322864 0.0333333 0.328864 0.0313333C0.386197 0.01 0.443531 0 0.502197 0H5.0022C5.2782 0 5.5022 0.224 5.5022 0.5C5.5022 0.776 5.2782 1 5.0022 1H1.70953L6.8562 6.14667C6.95086 6.24067 7.00286 6.36667 7.00286 6.5C7.00286 6.63333 6.95086 6.75933 6.8562 6.85333C6.76153 6.948 6.63553 7 6.5022 7Z"
        />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 16,
        },
        height: {
            type: [Number, String],
            default: 16,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: currentColor;
    stroke: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
